<template>
  <div class="container">
    <h4 class="title is-4">Savings</h4>
    <p>
      List liquid (easily converted to cash) savings. In most cases you only
      want to include savings you would actually use for living expenses.
      "Assets" aren't savings unless you plan to sell them and live off the
      proceeds.
    </p>
    <SavingsItems
      v-bind:savings_items="savings_items"
      v-bind:total_savings="total_savings"
      @del-sav="delSave"
    />
  </div>
</template>

<script>
import SavingsItems from "./SavingsItems.vue";

export default {
  name: "Savings",
  components: {
    SavingsItems,
  },
  props: {
    savings_items: Array,
    total_savings: Number,
  },
  data() {
    return {};
  },
  methods: {
    delSave(id) {
      this.$emit("del-sav", id);
    },
  },
};
</script>

<style>
</style>